module.exports = __webpack_public_path__ + "img/Anindya_Dutta.9da6c735.png";